import { FaReact, FaNode } from "react-icons/fa";
import {
  SiMaterialui,
  SiJavascript,
  SiRedux,
  SiGithub,
  SiStyledcomponents,
  SiBootstrap,
} from "react-icons/si";

export const skillsData = [
  {
    icon: <FaReact size="100px" color="#61dafb" />,
    title: "React JS",
    description:
      "Functional component, React Hooks, React Router, React Icons ",
  },
  {
    icon: <SiMaterialui size="100px" color="#007FFF" />,
    title: "MUI",
    description: " Material UI V5, Emotion, Styled Components, Theme ",
  },
  {
    icon: <SiRedux size="100px" color="#764abc" />,
    title: "Redux",
    description: "Using Redux and ReduxDevTools to manage state globally",
  },
  {
    icon: <SiJavascript size="100px" color="#f7df1e" />,
    title: "JavaScript",
    description: "Vanila JavaScript ES6",
  },
  {
    icon: <SiStyledcomponents size="100px" color="#fff" />,
    title: "Styled Components",
    description: "Creating And Styling components with Styled Components",
  },
  {
    icon: <SiBootstrap size="100px" color="#712cf9" />,
    title: "Bootsrap",
    description: "BootStrap 4 Classes, Grid, Media Queries, etc",
  },
  {
    icon: <FaNode size="100px" color="#43853d" />,
    title: "NodeJS",
    description: "Connecting to backend server with NodeJS",
  },

  {
    icon: <SiGithub size="100px" color="#fff" />,
    title: "GitHub",
    description: "GitHub Repository, Git, Github",
  },
];
